export default class DocumentDataEmployeeRepository {
  ofEmployee(employeeId, clientId) {}
}
